export default "__VITE_ASSET__BMfx8cI6__"